export enum RecommendationItemFieldsEnum {
  tasksAndStepsDefault = 'tasksAndStepsDefault',
}
